import React, {Component} from 'react';
import './Info.css';

export default class Info extends Component {
  render () {
    return (
      <div className="Info">
        <div className="label">{this.props.label}
        </div>
        <div className="value">
          {' '} {' '}
          <div className="value">{this.props.value}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Profile/Info/Info.js